import OrdemServicoEnderecoEntregaService from "@/services/OrdemServicoEnderecoEntregaService";

export const ordemServicoEnderecoEntrega = {
  namespaced: true,
  state: {
    ordemServicoEnderecoEntrega: {},
  },
  actions: {
    getOrdemServicoEnderecoEntrega({ commit }, payload) {
      return OrdemServicoEnderecoEntregaService.GetOrdemServicoEnderecoEntrega(
        payload
      ).then(
        (ordemServicoEnderecoEntrega) => {
          return Promise.resolve(ordemServicoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoEnderecoEntrega({ commit }, payload) {
      return OrdemServicoEnderecoEntregaService.PostOrdemServicoEnderecoEntrega(
        payload
      ).then(
        (ordemServicoEnderecoEntrega) => {
          return Promise.resolve(ordemServicoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoEnderecoEntrega({ commit }, payload) {
      return OrdemServicoEnderecoEntregaService.PutOrdemServicoEnderecoEntrega(
        payload
      ).then(
        (ordemServicoEnderecoEntrega) => {
          return Promise.resolve(ordemServicoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoEnderecoEntrega({ commit }, payload) {
      return OrdemServicoEnderecoEntregaService.DeleteOrdemServicoEnderecoEntrega(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoEnderecoEntregaOData({ commit }, payload) {
      return OrdemServicoEnderecoEntregaService.GetOrdemServicoEnderecoEntregaOData(
        payload
      ).then(
        (ordemServicoEnderecoEntrega) => {
          return Promise.resolve(ordemServicoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoEnderecoEntrega;
